// ==============================|| ACTION TYPES FOR CUSTOMIZATION REDUCER ||============================== //

// Action to set the sidebar/menu state (open/closed)
export const SET_MENU = '@customization/SET_MENU';

// Alternate menu set action (can be used separately if needed for other UI state control)
export const SET_MENU2 = '@customization/SET_MENU2';

// Toggle the menu state (typically used to flip the sidebar open/close)
export const MENU_TOGGLE = '@customization/MENU_TOGGLE';

// Mark a specific menu as open (based on ID)
export const MENU_OPEN = '@customization/MENU_OPEN';

// Change the font family in UI settings
export const SET_FONT_FAMILY = '@customization/SET_FONT_FAMILY';

// Change the border radius of UI elements
export const SET_BORDER_RADIUS = '@customization/SET_BORDER_RADIUS';

// Set or update user details in the Redux store
export const USER_DETAILS = '@customization/USER_DETAILS';
